// AUTO-GENERATED (scratchpad/gen_countries.py). Κοινή πηγή χωρών για dropdown + AADE mapping.
// value = name_en (ταιριάζει με aade_nationality_aliases -> alpha3 στο export).
import { NATIONALITY_ALIASES } from './nationalityAliases';

export interface Country { iso2: string; iso3: string; en: string; el: string; }
export const COUNTRIES: Country[] = [
  { iso2: "gr", iso3: "GRC", en: "Greece", el: "Ελλάδα" },
  { iso2: "cy", iso3: "CYP", en: "Cyprus", el: "Κύπρος" },
  { iso2: "mt", iso3: "MLT", en: "Malta", el: "Μάλτα" },
  { iso2: "it", iso3: "ITA", en: "Italy", el: "Ιταλία" },
  { iso2: "es", iso3: "ESP", en: "Spain", el: "Ισπανία" },
  { iso2: "pt", iso3: "PRT", en: "Portugal", el: "Πορτογαλία" },
  { iso2: "fr", iso3: "FRA", en: "France", el: "Γαλλία" },
  { iso2: "de", iso3: "DEU", en: "Germany", el: "Γερμανία" },
  { iso2: "at", iso3: "AUT", en: "Austria", el: "Αυστρία" },
  { iso2: "ch", iso3: "CHE", en: "Switzerland", el: "Ελβετία" },
  { iso2: "nl", iso3: "NLD", en: "Netherlands", el: "Ολλανδία" },
  { iso2: "be", iso3: "BEL", en: "Belgium", el: "Βέλγιο" },
  { iso2: "lu", iso3: "LUX", en: "Luxembourg", el: "Λουξεμβούργο" },
  { iso2: "gb", iso3: "GBR", en: "United Kingdom", el: "Ηνωμένο Βασίλειο" },
  { iso2: "ie", iso3: "IRL", en: "Ireland", el: "Ιρλανδία" },
  { iso2: "dk", iso3: "DNK", en: "Denmark", el: "Δανία" },
  { iso2: "se", iso3: "SWE", en: "Sweden", el: "Σουηδία" },
  { iso2: "no", iso3: "NOR", en: "Norway", el: "Νορβηγία" },
  { iso2: "fi", iso3: "FIN", en: "Finland", el: "Φινλανδία" },
  { iso2: "is", iso3: "ISL", en: "Iceland", el: "Ισλανδία" },
  { iso2: "pl", iso3: "POL", en: "Poland", el: "Πολωνία" },
  { iso2: "cz", iso3: "CZE", en: "Czech Republic", el: "Τσεχία" },
  { iso2: "sk", iso3: "SVK", en: "Slovakia", el: "Σλοβακία" },
  { iso2: "hu", iso3: "HUN", en: "Hungary", el: "Ουγγαρία" },
  { iso2: "ro", iso3: "ROU", en: "Romania", el: "Ρουμανία" },
  { iso2: "bg", iso3: "BGR", en: "Bulgaria", el: "Βουλγαρία" },
  { iso2: "hr", iso3: "HRV", en: "Croatia", el: "Κροατία" },
  { iso2: "si", iso3: "SVN", en: "Slovenia", el: "Σλοβενία" },
  { iso2: "rs", iso3: "SRB", en: "Serbia", el: "Σερβία" },
  { iso2: "ba", iso3: "BIH", en: "Bosnia and Herzegovina", el: "Βοσνία-Ερζεγοβίνη" },
  { iso2: "me", iso3: "MNE", en: "Montenegro", el: "Μαυροβούνιο" },
  { iso2: "mk", iso3: "MKD", en: "North Macedonia", el: "Βόρεια Μακεδονία" },
  { iso2: "al", iso3: "ALB", en: "Albania", el: "Αλβανία" },
  { iso2: "xk", iso3: "XKX", en: "Kosovo", el: "Κόσοβο" },
  { iso2: "ee", iso3: "EST", en: "Estonia", el: "Εσθονία" },
  { iso2: "lv", iso3: "LVA", en: "Latvia", el: "Λετονία" },
  { iso2: "lt", iso3: "LTU", en: "Lithuania", el: "Λιθουανία" },
  { iso2: "ua", iso3: "UKR", en: "Ukraine", el: "Ουκρανία" },
  { iso2: "by", iso3: "BLR", en: "Belarus", el: "Λευκορωσία" },
  { iso2: "ru", iso3: "RUS", en: "Russia", el: "Ρωσία" },
  { iso2: "md", iso3: "MDA", en: "Moldova", el: "Μολδαβία" },
  { iso2: "tr", iso3: "TUR", en: "Turkey", el: "Τουρκία" },
  { iso2: "il", iso3: "ISR", en: "Israel", el: "Ισραήλ" },
  { iso2: "lb", iso3: "LBN", en: "Lebanon", el: "Λίβανος" },
  { iso2: "jo", iso3: "JOR", en: "Jordan", el: "Ιορδανία" },
  { iso2: "sy", iso3: "SYR", en: "Syria", el: "Συρία" },
  { iso2: "sa", iso3: "SAU", en: "Saudi Arabia", el: "Σαουδική Αραβία" },
  { iso2: "ae", iso3: "ARE", en: "United Arab Emirates", el: "Ηνωμένα Αραβικά Εμιράτα" },
  { iso2: "qa", iso3: "QAT", en: "Qatar", el: "Κατάρ" },
  { iso2: "kw", iso3: "KWT", en: "Kuwait", el: "Κουβέιτ" },
  { iso2: "bh", iso3: "BHR", en: "Bahrain", el: "Μπαχρέιν" },
  { iso2: "om", iso3: "OMN", en: "Oman", el: "Ομάν" },
  { iso2: "ir", iso3: "IRN", en: "Iran", el: "Ιράν" },
  { iso2: "iq", iso3: "IRQ", en: "Iraq", el: "Ιράκ" },
  { iso2: "eg", iso3: "EGY", en: "Egypt", el: "Αίγυπτος" },
  { iso2: "ma", iso3: "MAR", en: "Morocco", el: "Μαρόκο" },
  { iso2: "tn", iso3: "TUN", en: "Tunisia", el: "Τυνησία" },
  { iso2: "dz", iso3: "DZA", en: "Algeria", el: "Αλγερία" },
  { iso2: "ly", iso3: "LBY", en: "Libya", el: "Λιβύη" },
  { iso2: "za", iso3: "ZAF", en: "South Africa", el: "Νότια Αφρική" },
  { iso2: "ng", iso3: "NGA", en: "Nigeria", el: "Νιγηρία" },
  { iso2: "ke", iso3: "KEN", en: "Kenya", el: "Κένυα" },
  { iso2: "us", iso3: "USA", en: "United States", el: "Ηνωμένες Πολιτείες" },
  { iso2: "ca", iso3: "CAN", en: "Canada", el: "Καναδάς" },
  { iso2: "mx", iso3: "MEX", en: "Mexico", el: "Μεξικό" },
  { iso2: "br", iso3: "BRA", en: "Brazil", el: "Βραζιλία" },
  { iso2: "ar", iso3: "ARG", en: "Argentina", el: "Αργεντινή" },
  { iso2: "cl", iso3: "CHL", en: "Chile", el: "Χιλή" },
  { iso2: "co", iso3: "COL", en: "Colombia", el: "Κολομβία" },
  { iso2: "pe", iso3: "PER", en: "Peru", el: "Περού" },
  { iso2: "ve", iso3: "VEN", en: "Venezuela", el: "Βενεζουέλα" },
  { iso2: "uy", iso3: "URY", en: "Uruguay", el: "Ουρουγουάη" },
  { iso2: "au", iso3: "AUS", en: "Australia", el: "Αυστραλία" },
  { iso2: "nz", iso3: "NZL", en: "New Zealand", el: "Νέα Ζηλανδία" },
  { iso2: "cn", iso3: "CHN", en: "China", el: "Κίνα" },
  { iso2: "jp", iso3: "JPN", en: "Japan", el: "Ιαπωνία" },
  { iso2: "kr", iso3: "KOR", en: "South Korea", el: "Νότια Κορέα" },
  { iso2: "in", iso3: "IND", en: "India", el: "Ινδία" },
  { iso2: "pk", iso3: "PAK", en: "Pakistan", el: "Πακιστάν" },
  { iso2: "bd", iso3: "BGD", en: "Bangladesh", el: "Μπαγκλαντές" },
  { iso2: "th", iso3: "THA", en: "Thailand", el: "Ταϊλάνδη" },
  { iso2: "vn", iso3: "VNM", en: "Vietnam", el: "Βιετνάμ" },
  { iso2: "ph", iso3: "PHL", en: "Philippines", el: "Φιλιππίνες" },
  { iso2: "id", iso3: "IDN", en: "Indonesia", el: "Ινδονησία" },
  { iso2: "my", iso3: "MYS", en: "Malaysia", el: "Μαλαισία" },
  { iso2: "sg", iso3: "SGP", en: "Singapore", el: "Σιγκαπούρη" },
  { iso2: "hk", iso3: "HKG", en: "Hong Kong", el: "Χονγκ Κονγκ" },
  { iso2: "tw", iso3: "TWN", en: "Taiwan", el: "Ταϊβάν" },
  { iso2: "ge", iso3: "GEO", en: "Georgia", el: "Γεωργία" },
  { iso2: "am", iso3: "ARM", en: "Armenia", el: "Αρμενία" },
  { iso2: "az", iso3: "AZE", en: "Azerbaijan", el: "Αζερμπαϊτζάν" },
  { iso2: "kz", iso3: "KAZ", en: "Kazakhstan", el: "Καζακστάν" },
];

// Λύνει ελεύθερο κείμενο ή value σε canonical Country (για εμφάνιση/ματσάρισμα).
// Δοκιμάζει: άμεσο match (en/el/iso2/iso3) → alias map (Israeli→ISR→Israel).
export function resolveCountry(v: string | undefined | null): Country | undefined {
  if (!v) return undefined;
  const k = String(v).trim().toLowerCase();
  const direct = COUNTRIES.find(c => c.en.toLowerCase() === k || (c.el || '').toLowerCase() === k || c.iso2 === k || c.iso3.toLowerCase() === k);
  if (direct) return direct;
  const a3 = NATIONALITY_ALIASES[k];
  if (a3) return COUNTRIES.find(c => c.iso3 === a3);
  return undefined;
}
